/* eslint-disable */
import { asyncComponent } from '../utils/asyncComponent';
import { isEmptyObj, isEmptyStr } from '../utils/utils';

export const RouteConfig = {
  '/home': {
    component: asyncComponent(() => import('../views/Home')),
  },
  '/product/my-product': {
    component: asyncComponent(() => import('../views/Product/MyPrd')),
  },
  '/product/prd-gather': {
    component: asyncComponent(() => import('../views/Product/PrdGather')),
  },
  '/trading/trading-manage': {
    component: asyncComponent(() => import('../views/Product/MyPrd')),
  },
  '/trading/trading-manage/trading-query': {
    component: asyncComponent(() => import('../views/DealCenter/DealQuery/DealQuery')),
  },
  '/trading/trading-manage/trading-query/trading-details/:id': {
    component: asyncComponent(() => import('../views/DealCenter/DealDetails/DealDetails')),
    pathidCof: '5-5',
  },
  '/trading/trading-manage/trading-query/trading-refund/:id': {
    component: asyncComponent(() => import('../views/DealCenter/RefundDetails/RefundDetails')),
    pathidCof: '5-5',
  },
  '/trading/trading-manage/batch-refund': {
    component: asyncComponent(() => import('../views/Product/MyPrd')),
  },
  '/trading/settle-manage/settle-detail': {
    component: asyncComponent(() => import('../views/DealCenter/SettleDetails/SettleDetails')),
  },
  '/trading/settle-manage/settle-detail/settle-list/:id': {
    component: asyncComponent(() => import('../views/DealCenter/SettleList/SettleList')),
    pathidCof: '5-5',
  },
  '/trading/trading-manage/refund-applyQuery': {
    component: asyncComponent(() => import('../views/DealCenter/RefundApplyQuery/RefundApplyQuery')),
  },
  '/trading/trading-manage/refund-batchQuery': {
    component: asyncComponent(() => import('../views/DealCenter/RefundBatchQuery/RefundBatchQuery')),
  },
  '/trading/trading-manage/refund-upload': {
    component: asyncComponent(() => import('../views/DealCenter/RefundUpload/RefundUpload')),
  },
  '/trading/trading-manage/trading-query/refund-apply': {
    component: asyncComponent(() => import('../views/DealCenter/RefundApply/RefundApply')),
  },
  '/merchant/operator-authority': {
    component: asyncComponent(() => import('../views/Product/MyPrd')),
  },
  '/merchant/operator-authority/operator-list': {
    component: asyncComponent(() => import('../views/Business/OperatorList')),
  },
  '/merchant/operator-authority/operator-list/operator-new': {
    component: asyncComponent(() => import('../views/Business/OperatorNew')),
  },
  '/merchant/operator-authority/role-manage': {
    component: asyncComponent(() => import('../views/Role')),
  },
};

const getAllFullPaths = function (menuConfig) {
  var fullPaths = [];

  if (!isEmptyObj(menuConfig)) {
    for (let i in menuConfig) {
      var c = menuConfig[i];

      if (isEmptyObj(c)) {
        continue;
      }

      fullPaths.push({ path: c.currentFullPath, level: c.menuLevel });

      if (!isEmptyObj(c.children) && c.children.length > 0) {
        fullPaths = fullPaths.concat(getAllFullPaths(c.children));
      }
    }
  }

  return fullPaths;
};

const getRouteStartWithX = function (x, routes) {
  const rs = [];

  for (let p in routes) {
    if (p.indexOf(x) === 0) {
      rs.push(p);
    }
  }

  return rs;
};

export const selectRoute = function (selectedMenuConfig) {
  const allFullPaths = getAllFullPaths(selectedMenuConfig);
  const routes = RouteConfig;
  const selectedRouteConfig = {};

  if (!isEmptyObj(allFullPaths) && !isEmptyObj(routes)) {
    for (let i in allFullPaths) {
      const p = allFullPaths[i];
      const path = p.path;
      const level = p.level;

      if (!isEmptyObj(routes[path])) {
        selectedRouteConfig[path] = routes[path];

        if (level === 3) {
          const subPaths = getRouteStartWithX(path, routes);

          for(let j in subPaths){
            let sp = subPaths[j];
            selectedRouteConfig[sp] = routes[sp];
          }
        }
      }
    }
  }
  return selectedRouteConfig;
};



// WEBPACK FOOTER //
// ./src/routes/routeUtils.js